import { PatternFormatFixed } from '../Inputs/NumberInput/types';
import { SummaryDisplayProps } from './types';

const SummaryDisplay = (props: SummaryDisplayProps) => {
    const {
        label,
        value,
        id,
        descriptor,
        as = 'span', // default props
        bodyText,
        containerClassName = '', // default props
        className = '', // default props
        format,
        mask,
        prepend,
        append,
        prefix,
        suffix,
        thousandSeparator,
        valueIsNumericString,
        allowNegative,
        allowemptyformatting,
        allowLeadingZeros,
        renderText,
        allowedDecimalSeparators,
    } = props;

    const renderFieldValue = () => {
        if (as === 'number' || format) {
            if (value) {
                return (
                    <>
                        <PatternFormatFixed
                            className={className}
                            displayType='text'
                            value={value}
                            format={format || undefined}
                            mask={mask}
                            prefix={prefix}
                            suffix={suffix}
                            valueIsNumericString={valueIsNumericString}
                            allowemptyformatting={allowemptyformatting}
                            renderText={renderText}
                            aria-hidden='true'
                            role='presentation'
                            autoComplete={undefined}
                            customInput={undefined}
                            disabled={undefined}
                            maxLength={undefined}
                            minLength={undefined}
                            placeholder={undefined}
                            readOnly={undefined}
                            type={undefined}

                        >
                            {/* {!!prepend && (prepend && ' ')}
                            {!!prefix && (prefix && ' ')} */}
                            {value}
                            {/* {!!suffix && (' ' && suffix) }
                            {!!append && (' ' && append) } */}
                        </PatternFormatFixed>
                        <span className='visually-hidden'>{value.split('').join(' ')}</span>
                    </>
                );
            }

            return (
                <span className={className}>
                    -
                    <span className='visually-hidden'>No details added</span>
                </span>
            );
        }

        if (as === 'p') {
            if (value) {
                // WCAG screen reader catch all fix for phone fields
                if (label?.toLowerCase().includes('phone')) {
                    return (
                        <>
                            <p className={`mb-0 text-break ${className}`} aria-hidden='true' role='presentation'>{value}</p>
                            <p className='visually-hidden'>{value.split('').join(' ')}</p>
                        </>
                    );
                }
                return (
                    <p className={`mb-0 text-break ${className}`}>{value}</p>
                );
            }

            return (
                <span className={className}>
                    -
                    <span className='visually-hidden'>No details added</span>
                </span>
            );
        }

        if (as === 'custom') {
            if (value) {
                return (
                    <>
                        {bodyText}
                    </>
                );
            }
            return (
                <span className={className}>
                    -
                    <span className='visually-hidden'>No details added</span>
                </span>
            );
        }

        if (as === 'span' || undefined) {
            if (value) {
                // WCAG screen reader catch all fix for phone fields
                if (label?.toLowerCase().includes('phone')) {
                    return (
                        <>
                            <span className={`mb-0 text-break ${className}`} aria-hidden='true' role='presentation'>{value}</span>
                            <span className='visually-hidden'>{value.split('').join(' ')}</span>
                        </>
                    );
                }
                return (
                    <span className={`text-break ${className}`}>{value}</span>
                );
            }

            return (
                <span className={className}>
                    -
                    <span className='visually-hidden'>No details added</span>
                </span>
            );
        }

        return null;
    };

    // if (descriptor?.length) {
    //     // eslint-disable-next-line no-console
    //     console.log(`Descriptor prop: ${descriptor}`);
    // }
    return (
        <div className={`mb-4 ${containerClassName}`}>
            {label && (
                <div className='form-label mb-0'>{label}</div>
            )}
            {renderFieldValue()}
            {!!descriptor && (
                <>
                    {' '}
                    <br />
                    <span className='text-break'>{descriptor}</span>
                </>
            )}
        </div>
    );
};

// SummaryDisplay.defaultProps = {
//     as: 'span',
//     containerClassName: '',
//     className: '',
// };

export default SummaryDisplay;
